import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "添加任务", -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "input-group mb-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "名称")
], -1)
const _hoisted_6 = { class: "input-group mb-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "链接")
], -1)
const _hoisted_8 = { class: "input-group-append" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "input-group mb-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "上传")
], -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "input-group-append" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
          placeholder: "默认为“任务+id+日期”, 若是上传, 则默认为上传文件名"
        }, null, 512), [
          [_vModelText, _ctx.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "url",
          class: "form-control",
          placeholder: "通过 m3u8 链接下载, 请在此处输入 m3u8 视频的链接, 然后点击确定",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.url) = $event))
        }, null, 512), [
          [_vModelText, _ctx.url]
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: !_ctx.url,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addTaskByURL && _ctx.addTaskByURL(...args)))
          }, "确定", 8, _hoisted_9)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("input", {
          type: "text",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args))),
          class: "form-control",
          style: {"cursor":"pointer","caret-color":"transparent"},
          value: _ctx.filename,
          placeholder: "通过 m3u8 文件下载, 请点击此处上传后缀为 .m3u8 的文件, 然后点击确定"
        }, null, 8, _hoisted_12),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: !_ctx.fileContent,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addTaskByFile && _ctx.addTaskByFile(...args)))
          }, "确定", 8, _hoisted_14)
        ])
      ])
    ])
  ]))
}